export enum ROLES {
  PERMIT_HOLDER = 1,
  OWNER = 2,
  PROPERTY_MANAGER = 3,
  OWNER_REPRESENTATIVE = 4,
  HOA = 5,
}

export enum ROLES_INFO {
  PERMIT_HOLDER = 'Permit Holder',
  OWNER = 'Owner',
  PROPERTY_MANAGER = 'Property Manager',
  OWNER_REPRESENTATIVE = 'Owner Representative',
  TENANT = 'Tenant',
  HOA = 'HOA',
}
